var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5418 10.5419C10.3421 10.7563 10.1012 10.9282 9.83357 11.0474C9.56593 11.1667 9.27702 11.2308 8.98407 11.236C8.69111 11.2412 8.40012 11.1873 8.12844 11.0775C7.85677 10.9678 7.60998 10.8045 7.4028 10.5973C7.19562 10.3901 7.03229 10.1433 6.92255 9.87164C6.81282 9.59997 6.75893 9.30897 6.7641 9.01602C6.76927 8.72307 6.83339 8.43415 6.95264 8.16652C7.07189 7.89889 7.24382 7.65801 7.45818 7.45827M13.32 13.3201C12.0768 14.2677 10.563 14.7927 9 14.8183C3.90909 14.8183 1 9.00008 1 9.00008C1.90465 7.31419 3.15937 5.84125 4.68 4.68008L13.32 13.3201ZM7.47273 3.35645C7.97333 3.23927 8.48586 3.18069 9 3.1819C14.0909 3.1819 17 9.00008 17 9.00008C16.5585 9.82598 16.032 10.6035 15.4291 11.3201L7.47273 3.35645Z",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L17 17",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.972263f3d11c553725699ab35a9b6e61.svg";
export { ForwardRef as ReactComponent };